import { FC } from "react";
import styled, { css } from "styled-components";

const Background: FC = () => {
  return (
    <Root>
      <LeftBack />
      <RightBack />
    </Root>
  );
};

export default Background;

const Root = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #000000;
  display: flex;
  justify-content: space-between;
`;

const sideBack = css`
  height: 100%;
  width: 20%;
  max-width: 350px;
  background-size: contain;
`;

const LeftBack = styled.div`
  ${sideBack};
  background-image: url("/image/lp/gonzo/bg/bg_l.jpg");
`;

const RightBack = styled.div`
  ${sideBack};
  background-image: url("/image/lp/gonzo/bg/bg_r.jpg");
`;
